import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Point1 from './Point1';
import Point2 from './Point2';
import Point3 from './Point3';
import Point4 from './Point4';
import Point5 from './Point5';
import './Dashboard.css';
import './Point1.css';
import './Point2.css';
import './Point3.css';
import './Point4.css';
import './Point5.css';
import axios from 'axios';

function Dashboard() {
  const [currentProject, setCurrentProject] = useState(null);
  const [selectedPoint, setSelectedPoint] = useState(0);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const project = localStorage.getItem('currentProject');
    if (project) {
      setCurrentProject(JSON.parse(project));
    } else {
      navigate('/projects');
    }
  }, [navigate]);

  const analysisPoints = [
    { number: 0, title: "Contextualización" },
    { number: 1, title: "Resumen Ejecutivo" },
    { number: 2, title: "Presentación de la Empresa" },
    { number: 3, title: "Análisis de Situación" },
    { number: 4, title: "Selección de Mercados" },
    //{ number: 5, title: "Plan de Acceso" }
  ];

  const renderPointContent = () => {
    switch(selectedPoint) {
      case 0:
        return (
          <div className="point-content">
            <h2>0. Contextualización</h2>
            <p>El presente informe se ha elaborado para la empresa en el marco del programa de consultoría de internacionalización.</p>
            <p>Este programa está dirigido a empresas exportadoras que tienen una concentración geográfica y que quieren ampliar sus mercados de actuación.</p>
            <p>Para ello, se analiza la posición de la empresa ante los mercados internacionales, se realiza un estudio de capacidad de compra por mercados, grado de penetración de productos similares, adecuación del producto al mercado y forma de acceder al mismo para tener éxito.</p>
          </div>
        );
      case 1:
        return <Point1 projectId={currentProject?.id} />;
      case 2:
        return <Point2 projectId={currentProject?.id} />;
      case 3:
        return <Point3 projectId={currentProject?.id} />;
      case 4:
        return <Point4 projectId={currentProject?.id} />;
      case 5:
        return <Point5 projectId={currentProject?.id} />;
      default:
        return (
          <div className="point-content">
            <h2>{analysisPoints[selectedPoint].number}. {analysisPoints[selectedPoint].title}</h2>
            <div className="analysis-interface">
              <AnalysisInterface 
                pointNumber={selectedPoint} 
                projectId={currentProject?.id}
              />
            </div>
          </div>
        );
    }
  };

  if (!currentProject) return <div>Cargando...</div>;

  return (
    <div className="dashboard">
      <Sidebar 
        currentProject={currentProject}
        user={user}
        selectedPoint={selectedPoint}
        setSelectedPoint={setSelectedPoint}
        analysisPoints={analysisPoints}
      />
      <main className="main-content">
        {renderPointContent()}
      </main>
    </div>
  );
}

function AnalysisInterface({ pointNumber, projectId }) {
  const [prompt, setPrompt] = useState('');
  const [useWeb, setUseWeb] = useState(false);
  const [searchTerms, setSearchTerms] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleAnalyze = async () => {
    if (!prompt.trim()) return;

    setLoading(true);
    try {
      const response = await axios.post('/api/analysis/', {
        project_id: projectId,
        point_number: pointNumber,
        prompt: prompt,
        use_web: useWeb,
        search_terms: searchTerms,
        web_only: false,
        priority_urls: null,
        use_deep_crawling: false
      });
      
      setResult(response.data);
    } catch (error) {
      console.error('Error en análisis:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="analysis-interface">
      <div className="analysis-form">
        <textarea
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          placeholder="Introduce el prompt para el análisis..."
          rows={6}
        />
        
        <div className="analysis-options">
          <label>
            <input
              type="checkbox"
              checked={useWeb}
              onChange={(e) => setUseWeb(e.target.checked)}
            />
            Usar búsqueda web
          </label>
          
          {useWeb && (
            <input
              type="text"
              value={searchTerms}
              onChange={(e) => setSearchTerms(e.target.value)}
              placeholder="Términos de búsqueda adicionales..."
            />
          )}
        </div>
        
        <button 
          onClick={handleAnalyze}
          disabled={loading || !prompt.trim()}
          className="analyze-btn"
        >
          {loading ? 'Analizando...' : 'Analizar'}
        </button>
      </div>

      {result && (
        <div className="analysis-result">
          <h3>Resultado del Análisis</h3>
          <div className="result-content">
            {result.content}
          </div>
          {result.sources.length > 0 && (
            <div className="sources">
              <h4>Fuentes utilizadas:</h4>
              <ul>
                {result.sources.map((source, index) => (
                  <li key={index}>{source}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Dashboard;